<template>
  <div>
    <HeaderforClever :showValue="1"></HeaderforClever>

    <!-- 菜单显示PC端 -->

    <div class="pcMenuItem_1" v-if="pcshow">
      <div class="pcMenuItem_2" >
        <div v-for="item in listCaiDan" :key="item.sort" >
          <!-- <a :href="item.route" class="justcolor">{{ item.title }}</a> -->
          <!-- <a href="javascript:;" @click="rountPage(item.sort)"> -->
          <a :href="item.route" >
            <div class="pcMenuItem_3" v-if="item.hideIs" :style="$route.query.ids == item.sort ? 'background:rgb(107 7 7)' : ''">
              <img src="~@/assets/public/gaikuan1.png" class="marBot5" />
              {{ item.title }}
            </div>
          </a>
        </div>
      </div>
    </div>

    <!-- 菜单显示移动端 -->
    <div v-else style="width: 100%; background-color: rgb(227 227 227 / 84%)">
      <div class="tab">
        <div class="table-item" v-for="item in listCaiDan" :key="item.sort">
          <a :href="item.route" >
          <span
            :style="showValue == item.sort ? styletable : mapStyle"
            class="tab-link"
           v-if="item.hideIs"
            >{{ item.title }}</span></a>
            <!--  @click="rountPage(item.sort)" -->
        </div>
      </div>
    </div>

    <div
      class="jqgk"
      style=";padding-left:40px;padding-right:40px;margin-bottom: 40px"
      :style="pcshow? 'background:rgba(227, 227, 227, 0.84)':'background:#fff'"
    >
      <div class="contai" style="max-width:1197px;">
        <div class="top_tit" style="margin-top:20px">
          <div class="titleShuXian" v-if="pcshow"></div>
          <span class="titleFont" v-if="pcshow">{{ newchina }}</span>
          <div class="titleShuXianForPhone" v-if="!pcshow"></div>
          <span class="titleFont" style="font-size:16px" v-if="!pcshow">{{ newchina }}</span>
          <div style="height:1px;width:100%"></div>
          <div style="text-align:left;margin:0px">
            <div class="travel_con" v-if="pcshow">
              <div class="">
                <!-- PC端-->
                <el-row style="margin-right:0px;margin-top:85px">
                  <div>
                    <el-col  :xs="24"  :sm="24" :md="24" :lg="24"  :xl="24"  style="background-color:#fff;padding:20px;text-align:center">
                     <div v-if="showCode">
                     <br/>
                        <br/>
                        <br/>
                        <br/>
                        <h3>网站升级中，敬请期待！</h3>
                        <br/>
                        <br/>
                        <br/>
                        <br/>
                      <br/>
                      </div>
                      <div v-else>
                        <img :src="htmlList[checkid-1].img" />
                        <div class="vhtmlClass"  v-html="htmlList[checkid-1].content"></div>
                      </div>
                    </el-col>
                  </div>
                </el-row>
              </div>
            </div>

            <!--  手机端 -->
            <div v-if="!pcshow" class="showPictureforCulture">
              <div>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="background-color:#fff;padding:10px;text-align:center" >
                    <div v-if="showCode">
                    <h4>网站升级中，敬请期待！......</h4>
                    <br/>
                      </div>
                      <div v-else>
                        <img :src="htmlList[checkid-1].img" />
                        <div class="vhtmlClass"  v-html="htmlList[checkid-1].content"></div>
                      </div>
                    </el-col>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import HeaderforClever from './headerforclever'
import Footer from './footer'
import { getActivity, getZHIYOUListAll } from '@/api/public'
export default {
  components: { HeaderforClever, Footer },
  data () {
    return {
      showCode: false,
      checkid: 0,
      newchina: '',
      choseValue: 1,
      pcshow: false,
      styletable: { color: '#fff', background: '#840207', padding: '5px', 'border-radius': '5px' },
      mapStyle: { color: '#840207', background: '#fff5e0', padding: '5px', 'border-radius': '5px' },
      dataList: [],
      htmlList: ['<p class=left>票务预订</p><br/>', '<p class=left>团队预定</p><br/>',
        {'imgdesc': '微信扫码立即预定房间', 'content': '<p class=centercontent>微信扫码立即预定房间</p><br/><p class=left>使用说明</p><br/><p class=left>1、须至少提前半天确认预订，房价含房间额定人数的进山门票和观光车票</p><br/><p class=left>2、入住当天请于下午16:30前到店办理好入住手续</p><br/><p class=left>3、须带备身份证入住，请配合做好公安系统资料录入</p><br/><p class=left>4、如需退订须于当天14:00前取消订单</p><br/><p class=left>5、进入景区请提前预约，亮码进园</p><br/><p class=left>6、进入景区凭预定信息换取门票和观光车票（超出部分需购票）</p><br/><p class=left>7、景区开放时间7:30-17:30，观光车运营时间8:30-17:30，请合理安排时间进山</p><br/><p class=left>8、乘坐观光车可在南门或北门乘车进山</p><br/><p class=left>9、成功预订房间后由工作人员通过电话方式确认订单，请留意接听</p><br/><p class=left>10、不可携带宠物入住，室内不可吸烟</p><br/><p class=left>11、入住请做好个人防护，注意卫生</p><br/>', 'img': require('@/img/hotal.jpg')},
        {'content': '<p class=centercontent>微信扫码预约导游</p><br/><p class=left>一、温馨提示：</p><br/><p class=left>1.市民游客可提前7天进行预约，导赏日期前一天中午12点前停止预约。</p><br/><p class=left>2.每个时间段只可预约一个景点。</p><br/><p class=left>二、服务条款：</p><br/><p class=left>用户享有、监督、反馈预约先约定的导赏服务；积极协助用户出行，为用户的个人和出行信息保密</p><br/>', 'img': require('@/img/parking.jpg')}, '<p class=left>餐饮预定</p><br/>', '<p class=left>文创产品商城</p><br/>', {'content': '<p class=centercontent>微信扫码查看停车指引</p><br/>', 'img': require('@/img/parking.jpg')}, {}, {}],
      listCaiDan: [
        // { sort: 1, title: "在线咨询" },
        // { sort: 3, title: "文创产品商城" },
        // { sort: 2, title: "停/寻车服务" },
        // { sort: 4, title: "导游预订" }
      ]

    }
  },
  beforeCreate () {},
  created () {
    this.checkid = this.$route.query.ids
    // eslint-disable-next-line no-unused-expressions
    Number(this.$route.query.ids) === 9 ? this.showCode = true : this.showCode = false
    if (this._isMobile()) {
      this.pcshow = false
    } else {
      this.pcshow = true
    }
    this.newchina = this.listCaiDan[this.$route.query.ids - 1].title
    // if (this.$route.query.ids == 1) {
    //   this.newchina = "在线咨询";
    //   this.checkid = 1;
    // }
    // if (this.$route.query.ids == 2) {
    //   this.newchina = "停/寻车服务";
    //   this.checkid = 2;
    // }
    // if (this.$route.query.ids == 3) {
    //   this.newchina = "文创产品商城";
    //   this.checkid = 3;
    // }
    // if (this.$route.query.ids == 4) {
    //   this.newchina = "导游预订";
    //   this.checkid = 4;
    // }
  },
  //  监听路由变化
  watch: {
    $route (to, from) {
      this.checkid = this.$route.query.ids
      // eslint-disable-next-line no-unused-expressions
      Number(this.$route.query.ids) === 9 ? this.showCode = true : this.showCode = false
      this.newchina = this.listCaiDan[this.$route.query.ids - 1].title
      // if (ids == 1) {
      //   this.checkid = 1;
      //   this.newchina = "在线咨询";//listCaiDan[]
      // } else if (ids == 2) {
      //   this.checkid = 2;
      //   this.newchina = "停/寻车服务";
      // } else if (ids == 3) {
      //   this.checkid = 3;
      //   this.newchina = "文创产品商城";
      // } else {
      //   this.checkid = 4;
      //   this.newchina = "导游预订";
      // }
    }
  },
  mounted () {
    getZHIYOUListAll().then(response => {
      this.listCaiDan = response.data
      this.newchina = this.listCaiDan[this.$route.query.ids - 1].title
    })
    getActivity().then(response => {
      this.dataList = response.data
    })
  },
  methods: {
    // 属性排序sort
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    rountPage (index) {
      this.$router.push({
        path: '/CleverAllOver',
        query: {
          ids: index
        }
      })
      // if (index == 1) {
      //   this.$router.push({
      //     path: "/CleverAllOver",
      //     query: {
      //       ids: index
      //     }
      //   });
      // }
      // if (index == 2) {
      //   this.$router.push({
      //     path: "/CleverAllOver",
      //     query: {
      //       ids: index
      //     }
      //   });
      // }
      // if (index == 3) {
      //   this.$router.push({
      //     path: "/CleverAllOver",
      //     query: {
      //       ids: index
      //     }
      //   });
      // }
      // if (index == 4) {
      //   this.$router.push({
      //     path: "/CleverAllOver",
      //     query: {
      //       ids: index
      //     }
      //   });
      // }
    },
    // 判断是PC端还是手机端
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 菜单选择
    tabSelect (e) {
      let value = e.target.dataset.index
      this.choseValue = value
    },
    // 详情()
    seeInfo (infoid) {
      this.$router.push({
        path: '/InfomationAllOverDetails',
        query: {
          id: infoid
        }
      })
    },
    toWailian () {
      window.open('https://weibo.com/u/2029893541')
    }
  }
}
</script>
<style>
.newCenter{
  justify-content:center !important;
  display: flex;
  flex-direction: row;
}
.titleShuXian {
  height: 48px;
  margin-top: 9px;
  width: 8px;
  background-color: #840207;
  float: left;
}
.titleShuXianForPhone {
  height: 28px;
  margin-top: 14px;
  width: 4px;
  background-color: #840207;
  float: left;
}
.titleFontEnglishForPhone {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 0px;
}
.titleFontEnglish {
  font-size: 21px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ccc;
  line-height: 66px;
  float: left;
  padding-top: 10px;
  padding-bottom: 15px;
}
.tra_tab {

  font-size: 28px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  width: 193px;
  height: 67px;
  text-align: center;
  line-height: 67px;
  cursor: pointer;
}
.tra_tab_mobile {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: #840207;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 10px;
}
.tra_tab_line_mobile {
  display: block;
  width: 100%;
  height: 2px;
  background: #840207;
  opacity: 0.1;
}
.tra_tab_line {
  display: block;
  width: 100%;
  height: 8px;
  background: #840207;
  opacity: 0.1;
}
.titleFont {
  font-size: 42px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #840207;
  line-height: 36px;
  float: left;
  padding: 15px;
}
.sceneryImgSizeforCulture {
  padding: 20px;
  height: 200px;
  width: 280px;
  float: left;
  display: block;
}
.sceneryFontSizeforCulture {
  font-size: 16x;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 917px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
  margin-top: 15px;
  float: left;
}
.showPictureforCulture {
  /* display: flex;
  flex-direction: column; */
  /* background-color: #ffffff; */
}
.sceneryDescFontSizeforCulture {
  float: left;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  width: 917px;
  height: 90px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.sceneryBtnforCulture {
  float: left;
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: black;
  width: 120px;
  height: 35px;
  padding: 0 20px;
  border: 1px solid #ccc;
  background-color: #fff;
  margin-left: 20px;
}
.sceneryFontSize {
  font-size: 20px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 270px;
  height: 40px;
  line-height: 40px;
  padding: 0 20px;
}
.mobileSceneryDescFontSize {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #484848;
  line-height: 30px;
  text-align: left;
  padding: 0 20px;
  margin-bottom: 20px;
  max-height: 60px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.mobileSceneryBtn {
  font-size: 18px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 126px;
  height: 44px;
  background: #840207;
  border: none;
  margin-right: 10px;
  margin-bottom: 5px;
}
.mobileSceneryBtnFor {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: 400;
  color: #ffffff;
  width: 86px;
  background: #840207;
  border: none;
}
p .left{
  text-align: left;
}
p .centercontent{
  text-align: center;
  /* line-height: 50px; */
  /* font-weight: bold !important; */

}
.vhtmlClass{
  font-weight: bold !important;
  font-size: 16px;
  margin-left: 10px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/CleverAllOver.vue